import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon([
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-500, #666666)",
        d: "M20 11.375a.7497.7497 0 0 0-.75.75v3.6875a.564.564 0 0 1-.5632.5625H3.3132a.564.564 0 0 1-.5632-.5625V4.9375a.564.564 0 0 1 .5633-.5625H12.25a.7499.7499 0 0 0 .5303-1.2803.75.75 0 0 0-.5303-.2197H3.3133A2.0655 2.0655 0 0 0 1.25 4.9375v10.875a2.0654 2.0654 0 0 0 2.0633 2.0625H10.25v1.5H8a.7498.7498 0 0 0-.5303 1.2803A.75.75 0 0 0 8 20.875h6a.7497.7497 0 0 0 .75-.75.7497.7497 0 0 0-.75-.75h-2.25v-1.5h6.9368a2.066 2.066 0 0 0 2.0632-2.0625V12.125a.7497.7497 0 0 0-.75-.75"
    }, "0"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-500, #666666)",
        fillRule: "evenodd",
        d: "M3.3133 2.625H12.25a1 1 0 1 1 0 2H3.3134A.314.314 0 0 0 3 4.9379V15.812a.314.314 0 0 0 .3136.3129h15.3728A.314.314 0 0 0 19 15.8118V12.125a1.0001 1.0001 0 0 1 2 0v3.6875a2.316 2.316 0 0 1-2.313 2.3125H12v1h2a1.0001 1.0001 0 0 1 0 2H8a1.0002 1.0002 0 0 1-.7071-1.7071A1 1 0 0 1 8 19.125h2v-1H3.3133A2.3153 2.3153 0 0 1 1 15.8129L.9999 4.9375a2.316 2.316 0 0 1 .6785-1.6346 2.316 2.316 0 0 1 1.6348-.6779m0 .5A1.8155 1.8155 0 0 0 1.5 4.9377v10.8746a1.8155 1.8155 0 0 0 1.8135 1.8127H10.5v2H8a.5.5 0 0 0-.5.5.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .3536-.1464.5004.5004 0 0 0 0-.7072A.5.5 0 0 0 14 19.625h-2.5v-2h7.1865A1.8154 1.8154 0 0 0 20.5 15.8121V12.125a.5.5 0 0 0-.1464-.3536.5004.5004 0 0 0-.7072 0 .5.5 0 0 0-.1464.3536v3.6875a.816.816 0 0 1-.2388.5745.814.814 0 0 1-.5741.238H3.3133a.814.814 0 0 1-.8132-.8118L2.4999 4.9375a.814.814 0 0 1 .813-.8125h8.937a.5002.5002 0 0 0 .3536-.8535.5.5 0 0 0-.3536-.1465z",
        clipRule: "evenodd"
    }, "1"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        d: "M15.5 2.125a.7499.7499 0 0 0-.5303 1.2803.75.75 0 0 0 .5303.2197 5.256 5.256 0 0 1 5.25 5.25.7498.7498 0 0 0 1.2803.5303.75.75 0 0 0 .2197-.5303 6.7577 6.7577 0 0 0-6.75-6.75"
    }, "2"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14.8813 2.2563A.875.875 0 0 1 15.5 2v.125L15.5001 2a6.883 6.883 0 0 1 6.8749 6.8749v.0001a.875.875 0 0 1-1.75.0001A5.1313 5.1313 0 0 0 15.4999 3.75a.875.875 0 0 1-.8749-.875.875.875 0 0 1 .2563-.6187m.6186-.0063A.6249.6249 0 0 0 15.5 3.5h.0001a5.381 5.381 0 0 1 5.3749 5.3749v.0001a.6247.6247 0 0 0 .625.625.625.625 0 0 0 .625-.6249A6.6324 6.6324 0 0 0 15.4999 2.25",
        clipRule: "evenodd"
    }, "3"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        d: "M17.75 8.875a.7498.7498 0 0 0 1.2803.5303.75.75 0 0 0 .2197-.5303 3.7546 3.7546 0 0 0-3.75-3.75.7499.7499 0 0 0-.5303 1.2803.75.75 0 0 0 .5303.2197 2.25 2.25 0 0 1 2.25 2.25"
    }, "4"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M14.8813 5.2563A.875.875 0 0 1 15.5 5h.0001a3.8795 3.8795 0 0 1 3.8749 3.8749v.0001a.875.875 0 0 1-1.75 0A2.125 2.125 0 0 0 15.5 6.75a.875.875 0 0 1-.6187-1.4937m.6186-.0063A.625.625 0 0 0 15.5 6.5a2.375 2.375 0 0 1 2.375 2.375.6247.6247 0 0 0 .625.625.625.625 0 0 0 .625-.6249A3.6297 3.6297 0 0 0 15.4999 5.25",
        clipRule: "evenodd"
    }, "5"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        d: "M15.5 9.625a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5"
    }, "6"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M15.5 8.25a.625.625 0 1 0 0 1.25.625.625 0 0 0 0-1.25m-.875.625a.875.875 0 1 1 1.75 0 .875.875 0 0 1-1.75 0",
        clipRule: "evenodd"
    }, "7")
], "ChannelCTV", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
